module.exports = __webpack_public_path__ + "assets/images/02_b37524e6018f3c8bde0f79203434c9e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-one/gameplay/02.png
// module id = 205
// module chunks = 0